import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TemporaryApproverUser } from '@rx-applications/clientsite/temporary-approver/utils';
import { HttpService } from '@rx-applications/shared/utils';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WebsiteUserAutoCompleteSearchBackend {
  #httpClient: HttpClient = inject(HttpClient);
  #httpService: HttpService = inject(HttpService);
  readonly #endpointDirectory = 'AutoComplete';

  searchWebsiteUserAutoComplete$(term: string): Observable<TemporaryApproverUser[]> {
    return this.#httpClient.get<TemporaryApproverUser[]>(
      `${this.#httpService.webApiUrl}${this.#endpointDirectory}/WebsiteUserAutoCompleteSearch?term=${term}&limit=6`,
    );
  }
}
